import { type ChangeEvent } from 'react';
import { InputAdornment, type SxProps, type Theme } from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';
import TextField from '@/components/TextField';
import styles from './styles';

type SearchFieldProps = {
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  size?: 'small' | 'medium';
  sx?: SxProps<Theme>;
  disabled?: boolean;
  fullWidth?: boolean;
  variant?: 'outlined' | 'filled' | 'standard';
};

const SearchField = ({
  value,
  onChange,
  placeholder = 'Search',
  size = 'small',
  sx,
  disabled,
  fullWidth,
  variant,
}: SearchFieldProps) => (
  <TextField
    name="search"
    label=""
    value={value}
    onChange={onChange}
    placeholder={placeholder}
    size={size}
    sx={{ ...styles.textField, ...sx }}
    disabled={disabled}
    fullWidth={fullWidth}
    variant={variant}
    slotProps={{
      input: {
        endAdornment: (
          <InputAdornment position="end" sx={styles.searchIcon}>
            <SearchIcon />
          </InputAdornment>
        ),
      },
    }}
  />
);

export default SearchField;
